import { Component, OnInit, inject } from '@angular/core';
import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular';
import { AuthState, OktaAuth } from '@okta/okta-auth-js';
import { filter, map } from 'rxjs';
import { LoaderService } from './services/loader.service';
import { UserInfoService } from './services/user-info.service';
import { isDefined } from './shared/utils/is-defined';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'admin-portal';
  public oktaAuth: OktaAuth = inject(OKTA_AUTH);
  private oktaStateService = inject(OktaAuthStateService);
  public userInfoService = inject(UserInfoService);
  public loaderService = inject(LoaderService);

  ngOnInit() {
    this.userInfoService.isAuthenticated$ =
      this.oktaStateService.authState$.pipe(
        filter((s: AuthState) => !!s),
        map((s: AuthState) => s.isAuthenticated ?? false)
      );
    this.userInfoService.isAuthenticated$
      .pipe(filter(isDefined))
      .subscribe(async () => {
        this.userInfoService.userInfoDetails = await this.oktaAuth.getUser();
        this.userInfoService.isUserInfoUpdated$.next(true);
      });
  }
}
